import request from "@/utils/request"

export function uploadImage(dir, file) {
  let formData = new FormData()
  formData.append('file', file)
  return request.post(`/upload/image/${dir}`, formData)
}

export function uploadVideo(dir, file) {
  let formData = new FormData()
  formData.append('file', file)
  return request.post(`/upload/video/${dir}`, formData)
}
